import { Link } from "react-router-dom";

const features = [
  {
    icon: "ri-hd-line",
    title: "蓝光高清画质",
    desc: "支持 1080P 及以上蓝光画质，自适应码率流畅播放。",
  },
  {
    icon: "ri-chat-smile-3-line",
    title: "实时弹幕互动",
    desc: "边看边聊，与主播和千万观众实时交流、发送弹幕。",
  },
  {
    icon: "ri-apps-2-line",
    title: "多频道聚合",
    desc: "游戏、娱乐、体育多频道分类，快速定位感兴趣内容。",
  },
  {
    icon: "ri-flashlight-line",
    title: "低延迟观看",
    desc: "优化传输链路，直播画面与现场几乎同步，告别卡顿。",
  },
];

export default function PlatformIntro() {
  return (
    <section className="w-full bg-background-50">
      <div className="mx-auto w-full max-w-[1440px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-5">
            <span className="mb-2 inline-flex items-center gap-1.5 text-xs font-label font-semibold uppercase tracking-[0.2em] text-primary-400">
              <span className="h-3 w-1 rounded-full bg-primary-500" />
              Why 360
            </span>
            <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-3xl">
              为什么选择 360直播
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              我们致力于为用户提供高品质、低延迟、易发现的直播观看体验。无论你热爱电竞赛事、音乐现场还是体育比赛，都能在这里找到属于你的频道。
            </p>
            <Link
              to="/about"
              className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              了解平台更多
              <i className="ri-arrow-right-line" />
            </Link>
          </div>

          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:col-span-7">
            {features.map((feature) => (
              <div
                key={feature.title}
                className="rounded-lg border border-background-200/60 bg-background-100 p-5 transition-colors hover:border-primary-500/50"
              >
                <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-500/15 text-primary-300">
                  <i className={`${feature.icon} text-xl`} />
                </span>
                <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">
                  {feature.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{feature.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}